export default __webpack_public_path__ + "static/media/step5.5c394383.svg";